export var InputBackgroundColor = {
  Primary: 'primary',
  Secondary: 'secondary'
};